<template>
    <div id="wt-accordion">
        <div v-for="(item, index) in accordionOptions" :key="index" @click="selected=index" class="my-2">
            <div class="btn wt-accordion-button" v-b-toggle="'accordion-' + index">
                <span>{{item.title}}</span>
            </div>
            <b-collapse :id="'accordion-' + index" class="my-2">
                <b-card class="wt-sub-form wt-accordion-sub-form">
                    <slot :name="'accordion-' + index"></slot>
                </b-card>
            </b-collapse>
        </div>
        <pre></pre>
        <pre></pre>
    </div>
</template>
<script>
export default {
  props: {
      accordionOptions: Array
  },
  components: {},
  computed: {},
  data: function() {
    return {
        selected: null,
        vindex: 0
    };
  },
  methods: {
    init() {
        this.$root.$emit('bv::toggle::collapse', 'accordion-0')
    },
  },
mounted() {
    this.init();
},   

};
</script>
